export const helphubUtil = (articleId: number) => {
  return window?.CommandBar?.openHelpHub({
    articleId: articleId,
  })
}
